import AvailableResultStep from '../../steps/AvailableResultStep'
import CheckingBody from '../../steps/CheckingBody'
import UnavailableResultStep from '../../steps/UnavailableResultStep'

interface ResultBodyProps {
  address: string
  isLoading: boolean
  /**
   * 1차 검증(`/service-area/availability`) 응답의 isAvailable.
   * - true → 수거 가능 (AvailableResultStep)
   * - false → 미오픈 지역 (UnavailableResultStep)
   * - undefined → 응답 전 (CheckingBody)
   */
  isAvailable: boolean | undefined
  isApplying: boolean
  /** "서비스 가능 지역 보기" 텍스트 버튼 — bridge `enterServiceArea` 핸들러 (네이티브가 화면 전환) */
  onEnterServiceArea: () => void
  onApply: () => void
}

/**
 * AddressSearchPage 결과 본문 분기.
 * - isLoading → 스피너
 * - isAvailable === true → AvailableResultStep
 * - isAvailable === false → UnavailableResultStep
 * - undefined (응답 전) → 스피너
 *
 * 4xx/5xx 에러는 page.tsx 의 useEffect 에서 bridge onError + 지도 복귀로 처리되므로 본문엔 도달 X.
 */
export default function ResultBody({
  address,
  isLoading,
  isAvailable,
  isApplying,
  onEnterServiceArea,
  onApply,
}: ResultBodyProps) {
  if (isLoading) return <CheckingBody />
  if (isAvailable === true) {
    return (
      <AvailableResultStep
        address={address}
        onApply={onApply}
        onEnterServiceArea={onEnterServiceArea}
        isApplying={isApplying}
      />
    )
  }
  if (isAvailable === false) {
    return <UnavailableResultStep address={address} onEnterServiceArea={onEnterServiceArea} />
  }
  return <CheckingBody />
}
